import React from "react";
import { useTranslation } from "react-i18next";
import LogoTag from "../../atoms/logo";
import "./style.scss";

const Footer = () => {
  const { t } = useTranslation();
  return (
    <div id="footer">
      <div className="contact">
        <LogoTag width="110" fill="#fff"></LogoTag>
        <p style={{ fontSize: 16 }}>{t("footer.serviceName")}</p>
        <p style={{ position: 'relative', top: 2 }}>{t("footer.support")}</p>
      </div>
      <div className="copyright">
        <p>{t("footer.copyright")}</p>
      </div>
    </div>
  );
};

export default Footer;
